import * as React from "react";
import { Link } from "gatsby";
import { IPageBannerProps } from "./PageBannerProps";
import {
  PageBannerWrapper,
  StyledContainer,
  Description,
  Title,
  StyledRow,
  CtaContainer,
  StickyContainer,
  MenuBarContent,
  isUrlExternal,
  SecondryTitle,
} from "./PageBannerHelpers";
import { Col } from "react-bootstrap";
import { useLocation } from "@reach/router";
import { GatsbyImage } from "gatsby-plugin-image";
import { imageWrapper } from "./PageBanner.module.scss";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

const PageBanner: React.FC<IPageBannerProps> = (props) => {
  const menu = props.menu;
  const { isMobileOnly } = useMobileDetectContext();
  const location = useLocation();
  let primaryPage = false;
  if (
    location &&
    (location.pathname.indexOf("/our-brands") != -1 ||
      location.pathname.indexOf("/about") != -1 ||
      location.pathname.indexOf("/offers") != -1 ||
      location.pathname.indexOf("/support") != -1)
  ) {
    primaryPage = true;
  }

  return (
    <PageBannerWrapper>
      <StyledContainer>
        <div className="overlay" />
        <GatsbyImage
          id="page-banner-image"
          image={props.image}
          alt={`Page Banner`}
          className={imageWrapper}
        />
        <StyledRow>
          <Col lg={6}>
            <CtaContainer minHeight={props.minHeight}>
              <Title
                titleId={`page-banner-title`}
                {...props}
                isPrimaryPage={primaryPage}
              ></Title>
              {props.secondaryTitle ? (
                <SecondryTitle
                  titleId={`page-banner-secondry-title`}
                  secondaryTitle={props.secondaryTitle}
                />
              ) : null}

              <Description decsId={`page-banner-desc`} {...props}></Description>
              {props.fieldLink !== null &&
                typeof props.fieldLink !== "undefined" && (
                  <div>
                    {isUrlExternal(props.fieldLink.url) ? (
                      <a
                        href={props.fieldLink.url}
                        id={`page-banner-link`}
                        target="_blank"
                        className="btn text-uppercase"
                        rel="noreferrer"
                      >
                        {props.fieldLink.title}
                      </a>
                    ) : (
                      <Link
                        id={`page-banner-link`}
                        to={props.fieldLink.url}
                        className="btn text-uppercase"
                      >
                        {props.fieldLink.title}
                      </Link>
                    )}
                  </div>
                )}
            </CtaContainer>
          </Col>
          <Col lg={6}></Col>
        </StyledRow>
      </StyledContainer>
      {/* {((typeof window !== "undefined") && (window.location.pathname == '/')) ? <BrandBar /> : <></>} */}
      {menu &&
        menu.length &&
        (isMobileOnly ? (
          <StickyContainer>
            <MenuBarContent brand={props.brand} menu={menu} />
          </StickyContainer>
        ) : (
          <MenuBarContent brand={props.brand} menu={menu} />
        ))}
    </PageBannerWrapper>
  );
};

export default PageBanner;
